/**
 * DOM anchors for frames the wall shows without a layout model (Part 06
 * decision 1): a Pinned row tile. Cards and windows resolve from their
 * models, never from here.
 */

export type FrameAnchorKind = "tile";

const anchors: Record<FrameAnchorKind, Map<string, HTMLElement>> = {
  tile: new Map(),
};
const listeners = new Set<() => void>();

function notify(): void {
  for (const listener of listeners) listener();
}

/** Register `element` as `kind` anchor of `id`; returns the unregister. */
export function registerFrameAnchor(
  kind: FrameAnchorKind,
  id: string,
  element: HTMLElement,
): () => void {
  anchors[kind].set(id, element);
  notify();
  return () => {
    if (anchors[kind].get(id) !== element) return;
    anchors[kind].delete(id);
    notify();
  };
}

export function frameAnchorElement(
  kind: FrameAnchorKind,
  id: string,
): HTMLElement | null {
  return anchors[kind].get(id) ?? null;
}

/** Fires when an anchor mounts or unmounts. */
export function subscribeFrameAnchors(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
